<template>
  <div class="part-id-preview" :class="{ disabled: disabled }"  :style="{ backgroundColor: disabled ? '#e7e7e7' : '' }">
    <div class="flex space-between v-center">
      <div>
        <h2 class="title">{{ title }}</h2>
      </div>
      <div v-if="showToggle && sequenceTemplates.length" class="flex v-center gap-1">
            <label class="switch">
            <input type="checkbox" @click="togglePartIdGeneration" :value="!disabled">
            <span class="slider round"></span>
            </label>
            </div>
    </div>

    <div
      v-if="showSequenceTemplateSelector && sequenceTemplates.length > 1"
      class="sequence-template-container"
      :class="disabled ? 'disabled--click' : ''"
    >
      <label>Sequence Template</label>
      <custom-dropdown
        :list="filteredSequenceTemplates"
        :selected="selectedSequenceTemplate"
        :search-text="sequenceTemplateSearch"
        :prevent-deselection="true"
        :disabled="disabled || sequenceTemplatesLoading"
        @toggle="sequenceTemplateSearch = ''"
        @select="handleSequenceTemplateSelection"
        @deselect="clearSequenceTemplateSelection"
      >
        <div slot="before-items" class="p-2 input-group xs">
          <input
            v-if="!sequenceTemplatesLoading && sequenceTemplates.length"
            placeholder="Search"
            type="text"
            v-model="sequenceTemplateSearch"
          />
          <div v-else class="xs py-1">
            {{ sequenceTemplatesLoading ? 'Loading templates...' : 'No templates found' }}
          </div>
        </div>
      </custom-dropdown>
    </div>
    <div class="preview-box" :class="disabled ? 'disabled--click' : ''">
      <div v-if="rulesLoading" class="small-loader center"><loading-circle/></div>
      <div v-else-if="sequenceTemplates.length === 0 && showTemplateSelector">
          <span>No sequence templates found. Please create a template to see the preview.</span>
      </div>
      <div v-else>
        <span v-for="(part, index) in previewPartId" :key="'part-' + index">
          <span v-if="part.clickable" class="selectable-part" @click="openDropdown(part)">{{
            part.displayValue
          }}</span>
          <span v-else>{{ part.displayValue}}</span></span>
      </div>
    </div>
    <div v-if="openDropdownObject.open && ['Config List', 'Tags'].includes(openDropdownObject.type)" :class="disabled ? 'disabled--click' : ''">
            <div>
        <div><label class="key">{{ openDropdownObject.type }}</label></div>
        <tagInput
          :tags="getSelectedTagLineData()"
          :title="openDropdownObject.type === 'Tags' ? 'Add tags' : 'Add values'"
          :type="openDropdownObject.tagType"
          :customListId="openDropdownObject.customListId"
          :allowMultipleRoots="false"
          :validateLeafSelection="false"
          :lastParentId="tagGroupData?.tagArray[selected_tag_line]?.at(-1)?.id"
          :tagGroupData="tagGroupData"
          @addNewTag="addnewTag"
          @parentLevelSelected="changeSelectedTagLine"
          @resetSelectedLine="resetSelectedTagLine"
          @focusTagLevel="focusTagLevel"
        />
        <div class="tag-container">
          <div class="tag-container"  >
            <div class="attached-values-section">
              <label class="key">Attached {{ openDropdownObject.type === 'Tags' ? 'Tags' : 'Values' }}:</label>
              <div :class="{'tags mt-2 p-1':true, 'tags-line-selected p-1': selected_tag_line===index }"  v-for="(tagParentwise,index) in tagGroupData.tagArray" :key="index" @click="selectTagLine(index)">
                <div v-for="(tag, cindex) in tagParentwise" :key="tag.id "  class="flex v-center tags-line ">
                    <img width="8px" src="~@/assets/images/right-arrow-icon.svg" alt="" :class="{ 'tags-line-first-img': cindex === 0 }" />
                  <div :class="{
                    'attached-tags v-center h-center ': true
                }"

                  >
                  {{ tag.name }}
                      <img
                  :class="{
                    'pointer ml-1 close-icon': true,
                    }"
                  @click="removeAttachedTags(tag.id)"
                  @mouseover="sethoveredtag(cindex,index)"
                  @mouseleave="sethoveredtag(null,null)"
                  src="~@/assets/images/icons/close-icon.svg" width="16px"
                />
                <div :class="{'attachedTags_overLay': cindex>=hoverd_tag?.cindex && index===hoverd_tag?.index}">
                </div>
                </div>

                </div>
              </div>
              <div v-if="tagGroupData.tagArray.length === 0">
                <b class="no-tag-found">No {{ openDropdownObject.type === 'Tags' ? 'tag' : 'value' }} is attached!</b>
              </div>
            </div>
            <div
              v-if="selectionValidationMessages[openDropdownObject.id]"
              class="selection-validation-message"
            >
              {{ selectionValidationMessages[openDropdownObject.id] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showCopyMaterialCheckbox" class="flex v-center mt-3 gap-2 pointer copy-material-name-container" @click="toggleCopyMaterialName">
      <checkbox :checked="copyMaterialName" style="pointer-events: none;" />
      <span class="pointer m-0">Copy extended sequence value to material name</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { TagTrie } from '@/utils/tagsHelper'
import TagInput from '@/components/common/tagAndConfigListInput.vue'
import CustomDropdown from '@/components/common/customDropdown.vue'
import LoadingCircle from './loadingCircle.vue'
import Checkbox from '@/components/common/checkbox.vue'
import {
  GetAllSequenceTemplates,
  GetIdGenerationRulesByFeatureId,
  SearchChildrenTags,
  GetCustomListChild
} from '@/api'

export default {
  name: 'PartIdPreview',
  components: {
    TagInput,
    CustomDropdown,
    LoadingCircle,
    Checkbox
  },
  props: {
    components: {
      type: Array,
      required: false,
      default: () => []
    },
    title: {
      type: String,
      required: false,
      default: 'Part ID Preview'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showToggle: {
      type: Boolean,
      default: false
    },
    showTemplateSelector: {
      type: Boolean,
      default: false
    },
    showCopyMaterialCheckbox: {
      type: Boolean,
      default: false
    },
    useFactoryToken: {
      type: Boolean,
      default: false
    },
    featureId: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      copyMaterialName: false,
      values: [],
      tagTries: {},
      previewPartId: '',
      selectedValues: {},
      selectedExtendedValues: {},
      currentDate: '',
      currentMonth: '',
      currentYear: '',
      tagGroupDataMap: {},
      tagGroupData: {
        firstLevelParents: [],
        tagArray: []
      },
      hoverd_tag: {
        cindex: null,
        index: null
      },
      selected_tag_line: 0,
      lastParentId: null,
      openDropdownObject: {
        open: false,
        id: '',
        type: '',
        list: [],
        tagType: null,
        customListId: null,
        useAbbreviation: false,
        suffix: ''
      },
      rulesLoading: false,
      sequenceTemplates: [],
      selectedSequenceTemplate: {},
      sequenceTemplateSearch: '',
      sequenceTemplatesLoading: false,
      selectedTemplateRules: [],
      childAvailabilityCache: {},
      selectionValidationMessages: {},
      selectionValidationRequestId: {},
      pendingSelectedTemplateId: null
    }
  },
  computed: {
    ...mapGetters(['user']),
    ...mapGetters('tag', ['getTags']),
    activeComponents () {
      return this.showTemplateSelector ? this.selectedTemplateRules : this.components
    },
    showSequenceTemplateSelector () {
      return this.showTemplateSelector && (this.sequenceTemplates.length > 0 || this.sequenceTemplatesLoading)
    },
    filteredSequenceTemplates () {
      if (!this.sequenceTemplateSearch.length) return this.sequenceTemplates
      return this.sequenceTemplates.filter((item) => {
        return item?.name?.toLowerCase().includes(this.sequenceTemplateSearch.toLowerCase())
      })
    }
  },
  watch: {
    components: {
      deep: true,
      handler () {
        if (!this.selectedTemplateRules.length) {
          this.initPreview()
        }
      }
    }
  },
  mounted () {
    const today = new Date()
    this.currentDate = today.getDate().toString().padStart(2, '0')
    this.currentMonth = (today.getMonth() + 1).toString().padStart(2, '0')
    this.currentYear = today.getFullYear()
    if (this.showTemplateSelector) this.fetchSequenceTemplates()
    this.initPreview()
  },
  methods: {
    ...mapMutations('tag', ['addNewTag', 'updateTags']),
    async fetchSequenceTemplates () {
      this.sequenceTemplatesLoading = true
      this.rulesLoading = true
      try {
        const res = await GetAllSequenceTemplates(this.featureId)
        this.sequenceTemplates = res?.core_sequence_id_template || []
        if (this.sequenceTemplates.length) {
          this.selectedSequenceTemplate = this.sequenceTemplates[0]
          this.$emit('sequenceIdSelected', this.selectedSequenceTemplate.id)
          await this.fetchRulesByTemplateId(this.selectedSequenceTemplate.id)
          if (this.pendingSelectedTemplateId) {
            await this.selectSequenceTemplateById(this.pendingSelectedTemplateId)
          }
        } else {
          this.rulesLoading = false
          this.sequenceTemplates = []
        }
      } catch (err) {
        this.sequenceTemplates = []
        this.rulesLoading = false
      } finally {
        this.sequenceTemplatesLoading = false
      }
    },
    async handleSequenceTemplateSelection (template) {
      this.selectedSequenceTemplate = template
      this.$emit('sequenceIdSelected', template.id)
      await this.fetchRulesByTemplateId(template.id)
    },
    async selectSequenceTemplateById (templateId) {
      if (!templateId) return false
      if (!this.sequenceTemplates.length) {
        this.pendingSelectedTemplateId = templateId
        return false
      }

      const matchedTemplate = this.sequenceTemplates.find(template => template.id === templateId)
      if (!matchedTemplate) {
        this.pendingSelectedTemplateId = templateId
        return false
      }

      this.pendingSelectedTemplateId = null
      await this.handleSequenceTemplateSelection(matchedTemplate)
      return true
    },
    clearSequenceTemplateSelection () {
      this.selectedSequenceTemplate = {}
      this.selectedTemplateRules = []
      this.selectedValues = {}
      this.tagMap = {}
      this.tagTries = {}
      this.openDropdownObject = {
        open: false,
        id: '',
        type: '',
        list: []
      }
      this.initPreview()
    },
    async fetchRulesByTemplateId (templateId) {
      this.rulesLoading = true
      try {
        const res = await GetIdGenerationRulesByFeatureId(templateId, this.useFactoryToken)
        this.selectedTemplateRules = res?.id_generation_rules || []
        this.selectedValues = {}
        this.tagMap = {}
        this.tagTries = {}
        this.openDropdownObject = {
          open: false,
          id: '',
          type: '',
          list: []
        }
        this.initPreview()
      } catch (err) {
        this.selectedTemplateRules = []
      } finally {
        this.rulesLoading = false
      }
    },
    togglePartIdGeneration (event) {
      event.stopPropagation()
      this.$emit('togglePartIdGeneration')
    },
    resetTags () {
      this.selectedValues = {}
      this.tagTrie.clearAll()
      this.tagGroupData = this.tagTrie.groupTagInArray()
      this.lastParentId = null
    },
    getSelectedTagLineData (partId = this.openDropdownObject.id, lineIndex = this.selected_tag_line) {
      const trie = this.tagTries[partId]
      if (!trie) return []
      const groupedTagData = trie.groupTagInArray()
      return groupedTagData.tagArray[lineIndex] || []
    },
    getChildAvailabilityCacheKey ({ itemId, type, tagType, customListId }) {
      return `${type}-${tagType ?? 'na'}-${customListId ?? 'na'}-${itemId}`
    },
    getAggregateChildCount (item) {
      const count = item?.child_values_aggregate?.aggregate?.count
      return typeof count === 'number' ? count : null
    },
    syncChildAvailabilityCacheFromItem (item, options = {}) {
      const aggregateCount = this.getAggregateChildCount(item)
      if (aggregateCount === null) return
      const cacheKey = this.getChildAvailabilityCacheKey({
        itemId: item.id,
        type: options.type ?? this.openDropdownObject.type,
        tagType: options.tagType ?? this.openDropdownObject.tagType,
        customListId: options.customListId ?? this.openDropdownObject.customListId
      })
      this.$set(this.childAvailabilityCache, cacheKey, aggregateCount > 0)
    },
    async hasChildOptions ({ itemId, type, tagType, customListId }) {
      const cacheKey = this.getChildAvailabilityCacheKey({ itemId, type, tagType, customListId })
      if (this.childAvailabilityCache[cacheKey] !== undefined) {
        return this.childAvailabilityCache[cacheKey]
      }
      let hasChildren = false
      if (type === 'Tags') {
        const res = await SearchChildrenTags(itemId, '', tagType)
        hasChildren = (res?.tag || []).length > 0
      } else if (type === 'Config List') {
        const res = await GetCustomListChild(itemId)
        hasChildren = (res?.custom_list_values || []).length > 0
      }
      this.$set(this.childAvailabilityCache, cacheKey, hasChildren)
      return hasChildren
    },
    clearSelectionForPart (partId) {
      this.$delete(this.selectedValues, partId)
      this.$delete(this.selectedExtendedValues, partId)
    },
    async validateAndComputeTagValue () {
      const partId = this.openDropdownObject.id
      if (!partId) return
      const selectedLine = this.getSelectedTagLineData(partId, this.selected_tag_line)
      if (!selectedLine.length) {
        this.clearSelectionForPart(partId)
        this.$set(this.selectionValidationMessages, partId, '')
        this.initPreview()
        return
      }

      const requestId = (this.selectionValidationRequestId[partId] || 0) + 1
      this.$set(this.selectionValidationRequestId, partId, requestId)

      const lastTag = selectedLine[selectedLine.length - 1]
      const hasChildren = await this.hasChildOptions({
        itemId: lastTag.id,
        type: this.openDropdownObject.type,
        tagType: this.openDropdownObject.tagType,
        customListId: this.openDropdownObject.customListId
      })

      if (this.selectionValidationRequestId[partId] !== requestId) return

      if (hasChildren) {
        this.clearSelectionForPart(partId)
        this.$set(
          this.selectionValidationMessages,
          partId,
          `Please select the last child ${this.openDropdownObject.type === 'Tags' ? 'tag' : 'value'} before continuing.`
        )
        this.initPreview()
        return
      }

      let name = ''
      let extendedName = ''
      const id = lastTag.id
      for (let i = 0; i < selectedLine.length; i++) {
        if (this.openDropdownObject.useAbbreviation && selectedLine[i].abbreviation) {
          name += selectedLine[i].abbreviation
          extendedName += selectedLine[i].name
        } else {
          name += selectedLine[i].name
          extendedName += selectedLine[i].name
        }
        if (i !== selectedLine.length - 1) {
          name += this.openDropdownObject.suffix
        }
      }
      this.$set(this.selectedValues, partId, { id, name })
      this.$set(this.selectedExtendedValues, partId, { id, name: extendedName })
      this.$set(this.selectionValidationMessages, partId, '')
      this.initPreview()
    },
    openDropdown (part) {
      if (this.openDropdownObject.id === part.id) {
        this.openDropdownObject = {
          open: false,
          id: '',
          type: '',
          list: [],
          tagType: null,
          customListId: null,
          useAbbreviation: false,
          suffix: ''
        }
        return
      }
      this.openDropdownObject.open = true
      this.openDropdownObject.id = part.id
      this.openDropdownObject.type = part.caption
      this.openDropdownObject.list = part.list
      this.openDropdownObject.useAbbreviation = part?.useAbbreviation ?? false
      this.openDropdownObject.suffix = part.suffix
      if (part.caption === 'Tags') {
        this.openDropdownObject.tagType = part.tagType
        this.openDropdownObject.customListId = null
      } else if (part.caption === 'Config List') {
        this.openDropdownObject.tagType = null
        this.openDropdownObject.customListId = part.customListId
      }
      if (part.caption === 'Tags' || part.caption === 'Config List') {
        if (!this.tagTries[part.id]) {
          this.tagTries[part.id] = new TagTrie()
        }
        this.tagGroupData = this.tagTries[part.id].groupTagInArray()
        this.selected_tag_line = 0
        this.validateAndComputeTagValue()
      }
    },
    initPreview () {
      this.values = []
      this.previewPartId = this.activeComponents.map((comp) => {
        const displayValue = this.getComponentDisplayValue(comp)
        if (comp.component.caption === 'Config List' || comp.component.caption === 'Tags') {
          this.values.push({
            sequence: comp.sequence_order,
            value: this.selectedValues[comp.id]?.id ?? null,
            delimiter: comp.delimiter_after ?? null,
            caption: comp.component.caption,
            displayValue,
            extendedValue: this.getExtendedValue(comp)
          })
        } else {
          this.values.push({
            sequence: comp.sequence_order,
            value: displayValue,
            delimiter: comp.delimiter_after ?? null,
            caption: comp.component.caption,
            displayValue,
            extendedValue: displayValue
          })
        }
        const returnList = {
          displayValue: `${displayValue}${
            comp.delimiter_after ?? ''
          }`,
          clickable:
            comp.component.caption === 'Config List' ||
            comp.component.caption === 'Tags',
          caption: comp.component.caption,
          useAbbreviation: comp.use_abbreviation ?? false,
          id: comp.id,
          list: []
        }
        if (comp.component.caption === 'Config List') {
          returnList.list = comp.core_custom_list?.custom_list_values
          returnList.customListId = comp.custom_list_id
          returnList.suffix = comp.suffix
        } else if (comp.component.caption === 'Tags') {
          returnList.list = comp.tag_type?.tags
          returnList.tagType = comp.tag_type_id
          returnList.suffix = comp.suffix
        }
        return returnList
      })
      this.$emit('update', this.values, this.copyMaterialName)
    },
    toggleCopyMaterialName (val) {
      if (typeof val === 'boolean') {
        this.copyMaterialName = val
      } else {
        this.copyMaterialName = !this.copyMaterialName
      }
      this.$emit('update', this.values, this.copyMaterialName)
    },
    computeTagValue () {
      this.validateAndComputeTagValue()
    },
    getExtendedValue (comp) {
      return this.selectedExtendedValues[comp.id]?.name ?? ''
    },
    getCustomListPlaceholder (comp) {
      const customListName = comp.core_custom_list?.name || ''
      return customListName ? `[${customListName}]` : '[Custom_List_Select]'
    },
    getComponentDisplayValue (comp) {
      switch (comp.component.caption) {
      case 'Text':
        return comp.default_value
      case 'Number':
        return comp.default_value
      case 'User Initials':
        return (
            this.user.first_name?.charAt(0).toUpperCase() +
            this.user.last_name?.charAt(0).toUpperCase()
        )
      case 'Auto Sequence':
        return '###'
      case 'UUID':
        return 'xxxx-xxxx'
      case 'Year':
        return this.currentYear
      case 'Month':
        return this.currentMonth
      case 'Date':
        return this.currentDate
      case 'Tags':
        return this.selectedValues[comp.id]?.name ?? '[Tag_Select]'
      case 'Config List':
        if (this.selectedValues[comp.id]?.name) {
          if (comp.use_abbreviation && this.selectedValues[comp.id]?.abbreviation) {
            return this.selectedValues[comp.id]?.abbreviation
          } else {
            return this.selectedValues[comp.id]?.name
          }
        } else {
          return this.getCustomListPlaceholder(comp)
        }
      default:
        return '[value]'
      }
    },
    removeAttachedTags (tagId) {
      const trie = this.tagTries[this.openDropdownObject.id]
      trie.deleteTagById2(tagId)
      this.tagGroupData = trie.groupTagInArray()
      if (!this.tagGroupData.tagArray[this.selected_tag_line]) {
        this.selected_tag_line = 0
      }
      this.computeTagValue()
    },
    sethoveredtag (cindex, index) {
      this.hoverd_tag.cindex = cindex
      this.hoverd_tag.index = index
    },
    normalizeRowPayload (payload) {
      if (payload && typeof payload === 'object') return payload
      return { id: payload, rowIndex: this.selected_tag_line }
    },
    addnewTag (payload) {
      const { tag, rowIndex } = this.normalizeRowPayload(payload)
      if (typeof rowIndex === 'number') {
        this.selected_tag_line = rowIndex
      }
      if (!tag) return
      this.syncChildAvailabilityCacheFromItem(tag)
      const trie = this.tagTries[this.openDropdownObject.id]
      trie.insertTag({ name: tag.name, id: tag.id, parentId: tag.parent_id ?? tag.parentId ?? null, abbreviation: tag.abbreviation })
      this.tagGroupData = trie.groupTagInArray()
      if ((tag.parent_id ?? tag.parentId ?? null) === null) {
        this.changeSelectedTagLine({ id: tag.id, rowIndex })
      }
      this.computeTagValue()
    },
    changeSelectedTagLine (payload) {
      const { id, rowIndex } = this.normalizeRowPayload(payload)
      if (typeof rowIndex === 'number') {
        this.selected_tag_line = rowIndex
      }
      if (id === null) {
        if (typeof rowIndex !== 'number') this.selected_tag_line = 0
      } else {
        this.tagGroupData.tagArray.forEach((element, index) => {
          if (element[0].id === id) { this.selected_tag_line = index }
        })
      }
      this.computeTagValue()
    },
    resetSelectedTagLine (payload) {
      const { rowIndex } = this.normalizeRowPayload(payload)
      if (typeof rowIndex === 'number') {
        this.selected_tag_line = rowIndex
      }
      const partId = this.openDropdownObject.id
      const trie = this.tagTries[partId]
      if (!trie) return
      const currentLine = this.getSelectedTagLineData(partId, this.selected_tag_line)
      if (currentLine.length) {
        trie.deleteTagById2(currentLine[0].id)
      }
      this.tagGroupData = trie.groupTagInArray()
      this.selected_tag_line = 0
      this.computeTagValue()
    },
    focusTagLevel (payload) {
      const { index, rowIndex } = this.normalizeRowPayload(payload)
      if (typeof rowIndex === 'number') {
        this.selected_tag_line = rowIndex
      }
      const partId = this.openDropdownObject.id
      const trie = this.tagTries[partId]
      if (!trie) return
      const currentLine = this.getSelectedTagLineData(partId, this.selected_tag_line)
      if (!currentLine.length) return
      const tagsToRemove = currentLine.slice(index)
      for (let i = tagsToRemove.length - 1; i >= 0; i--) {
        trie.deleteTagById2(tagsToRemove[i].id)
      }
      this.tagGroupData = trie.groupTagInArray()
      this.computeTagValue()
    },
    selectTagLine (index) {
      this.selected_tag_line = index
      this.computeTagValue()
    }
  }
}
</script>

<style lang="scss" scoped>
  .disabled {
    // opacity: 0.5;
    // background-color: rgba(0, 0, 0, 0.4);
    &--click {
      pointer-events: none;
    }
  }
.part-id-preview {
  .switch {
  position: relative;
  display: inline-block;
  width: 49px;
  height: 24px;
}

.small-loader {
  .loading-circle {
    font-size: var(--text-3xl) !important;
  }
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f6dcb3;
  border: 2px solid var(--brand-color);
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 2.5px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked+.slider {
background-color: var(--brand-color);
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196F3;
}
input:checked+.slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
  padding: 1.5rem;
  background-color: #fff;
  border: 1px solid rgba(59, 59, 59, 0.4666666667);
  border-radius: 0.285em;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .title {
    font-size: var(--text-l);
    font-weight: 600;
    color: #2d3748;
  }

  .preview-box {
    background-color: var(--bg-color);
    padding: 0.75rem 1rem;
    font-family: monospace;
    border-radius: 0.285em;
    border: 1px solid rgba(59, 59, 59, 0.4666666667);
    font-size: var(--text-m);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.03);
    .selectable-part {
      cursor: pointer;
      color: green;
      text-decoration: underline;
      &:hover {
        color: darken(green, 10%);
      }
    }
  }

  .copy-material-name-container {
    background-color: var(--bg-color);
    padding: 0.75rem 1rem;
    gap: 0.5rem;
    border-radius: 0.285em;
    font-size: var(--text-s);
    border: 1px dashed rgba(59, 59, 59, 0.4666666667);
    transition: background-color 0.2s ease, border-color 0.2s ease;
    &:hover {
      background-color: var(--brand-light-color, #edf2f7);
      border-color: var(--brand-color);
    }
    span {
      font-weight: 500;
      color: #2d3748;
      user-select: none;
    }
  }

  .breakdown {
    .subtitle {
      font-size: var(--text-l);
      font-weight: 600;
      color: #2d3748;
    }

    .components-row {
      display: flex;
      flex-wrap: wrap;
      gap: 0.75rem;
      align-items: center;
      margin-top: 0.5rem;

      .component-box {
        background-color: var(--bg-color);
        border: 1px solid rgba(59, 59, 59, 0.4666666667);
        border-radius: 0.285em;
        padding: 0.75rem 1.25rem;
        text-align: center;
        min-width: 100px;
        transition: background-color 0.2s ease;
        cursor: default;

        &:hover {
          background-color: var(--brand-color);
        }

        .component-caption {
          font-size: var(--text-xs1);
          font-weight: 600;
          text-transform: uppercase;
          margin-bottom: 0.25rem;
        }

        .component-value {
          font-size: var(--text-m);
          font-family: monospace;
          white-space: nowrap;
          text-overflow: ellipsis;
          &-selector {
            width: 20rem;
          }
        }
      }

      .delimiter {
        font-size: var(--text-2xl);
        font-weight: bold;
        color: #718096;
      }
    }
  }
}

.tags {
  display: flex;
flex-wrap: wrap;
margin-left: 5px;
  margin-right: 5px;
  row-gap: 5px;
   &-line-selected{
    background-color: var(--brand-light-color);
   border: .4px solid var(--brand-color);
   border-radius: 5px;
   min-width: min-content;
   }
}
.tag-container {
  margin-top: 4px;
}
.attached-values-section {
  display: none;
}

.no-tag-found{
  margin-left: 5px;
}
.selection-validation-message{
  margin: 8px 5px 0;
  color: #c53030;
  font-size: var(--text-xs2);
}
.attached-tags{
  cursor:pointer;
  background-color: var(--brand-color);
  padding: 0.6rem;
  font-size: small;
  border-radius: 0.4rem;
position:relative;
  &-fade{
background-color: rgb(0, 0,0,.6) ;
color:white
}
  & img{
 z-index:4;
  }
  & img{
    display: none;
  }
}
.tags-line{
  text-overflow: ellipsis;
  overflow: hidden;
   white-space: nowrap;
  & img{
    margin-inline: .5rem;
  }
  &-first-img{
    display: none;
  }
  .attached-tags:hover > img {
display: block;
scale: 1.2;
// -webkit-box-shadow:0px 0px 123px 21px rgba(215,224,221,0.78);
// -moz-box-shadow: 0px 0px 123px 21px rgba(215,224,221,0.78);
// box-shadow: 0px 0px 123px 21px rgba(215,224,221,0.78);
  }
  .attachedTags_overLay{
    background-color: black;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    opacity: .3;
    z-index: 1;
  }
}
</style>
